var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"online-menu"},[_c('online-menu-card'),_c('online-menu-background'),_c('online-menu-contact-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }